module.exports = __webpack_public_path__ + "media/images/icons/filled/notification-4e9d6f5235be09a5d89caab5e1337b12.svg";